import { useEffect, useState } from "react";
import type { IOrdersEdgesNode } from "../src/queries/customer-gql";
import { fetchCardInfo, PAYMENT_METHOD } from "../src/api/fetchCardInfo";

import type { Order } from "@shopify/hydrogen-react/storefront-api-types";
import type { IReturn } from "../src/api/fetchReturnOrder";

const STORE_NAME = import.meta.env.VITE_REACT_APP_SHOP_NAME as string;

/**
 * @description 결제 한 카드 정보 가져오기
 */
export default function useOrderPayMethod({
  order,
  lang,
  orderId,
}: {
  order?: Order | IOrdersEdgesNode | IReturn["order"] | null;
  lang: "ko" | "en" | "jp";
  orderId: string;
}) {
  const [paymentInfo, setPaymentInfo] = useState<string>("-");

  const getCardInfo = async () => {
    if (!order?.id) return;

    const response = await fetchCardInfo({ storeName: STORE_NAME, orderId, lang });

    if (response?.card) {
      setPaymentInfo(`${response.card.cardName}${response.card.cardType ? `(${response.card.cardType})` : ""}`);
    }

    if (response?.easyPayProvider) {
      setPaymentInfo(response.easyPayProvider);
    }
  };

  useEffect(() => {
    if (!orderId) return;

    if (lang === "ko") {
      void getCardInfo();
    } else {
      if (!order) return;

      const findTag = order.customAttributes?.find((item) => item.key === "paymentMethod");
      if (findTag) {
        setPaymentInfo(findTag.value ? PAYMENT_METHOD[findTag.value as keyof typeof PAYMENT_METHOD] : "-");
      } else {
        void getCardInfo();
      }
    }
  }, [lang, order]);

  return paymentInfo;
}
